import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TabContent } from './components/TabContent';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { SimpleTab } from '../../../CommonComponents/OPL/Tab/SimpleTab';
import { summarySelector } from '../../MoneyGuidProSelectors';

export const SummaryMobile = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const data = useSelector(summarySelector);

  if (!data) {
    return null;
  }

  return (
    <>
      <Box display="flex" mx="12" mt="24">
        <SimpleTab
          isActive={selectedIndex === 0}
          onClick={() => setSelectedIndex(0)}
          style={{ width: '50%' }}
        >
          Current Scenario
        </SimpleTab>
        <SimpleTab
          isActive={selectedIndex === 1}
          onClick={() => setSelectedIndex(1)}
          color="neutral.500"
          style={{ width: '50%' }}
        >
          Recommended
        </SimpleTab>
      </Box>
      <TabContent selectedIndex={selectedIndex} />
    </>
  );
};
